import { create } from 'zustand';

export interface LostItemDetailDialogTarget {
  lostItemId: number;
  productName?: string | null;
}

interface LostItemDetailDialogState {
  open: boolean;
  target: LostItemDetailDialogTarget | null;
  openLostItemDetail: (t: LostItemDetailDialogTarget) => void;
  closeLostItemDetail: () => void;
}

export const useLostItemDetailDialogStore = create<LostItemDetailDialogState>((set) => ({
  open: false,
  target: null,
  openLostItemDetail: (t) => set({ open: true, target: t }),
  closeLostItemDetail: () => set({ open: false, target: null }),
}));

export function openLostItemDetail(t: LostItemDetailDialogTarget) {
  useLostItemDetailDialogStore.getState().openLostItemDetail(t);
}

export function closeLostItemDetail() {
  useLostItemDetailDialogStore.getState().closeLostItemDetail();
}
